import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
// Removed PageHero import as we are building a custom image hero
import heroLV from '../../assets/heroLV.png'; // Update this path to your hero image

const LoansJV = () => {
  useEffect(() => {
    document.title = 'Loans & Joint Ventures | Eco World Capital';
  }, []);

  const jvHighlights = [
    { title: 'Minimum Investment', desc: '$100,000 and multiples (Equivalent to INR 1 Crore and above).' },
    { title: 'Lock-In Period', desc: 'Minimum Lock-In Period of Three (3) Years.' },
    { title: 'Profit & Loss Sharing', desc: 'Shared 65% to the Investor and 35% to EWC. Settlement defined in the JV Agreement.' },
    { title: 'Account Control & Fund Safety', desc: "The trading account remains fully in the Investor's name. The Investor is the mandatory signatory authority with no transfer of funds to EWC." },
  ];

  const jvMarkets = ['Indian & Global Equities', 'Currencies (Forex)', 'Bullion (Gold & Silver)', 'Indices', 'Cryptocurrencies (where legally permitted)'];

  const loanCategories = [
    { name: 'Business Loans' },
    { name: 'Working Capital Finance' },
    { name: 'Personal Loans' },
    { name: 'Home Loans' },
    { name: 'Mortgage Loans' },
    { name: 'Loan Against Property' },
    { name: 'MSME Financing' },
    { name: 'Customized Funding Solutions' },
  ];

  return (
    <PageShell>
      
      {/* --- NEW CUSTOM HERO SECTION --- */}
      <section className="relative w-full h-[60vh] min-h-[775px] md:h-[70vh] flex items-end pb-12 md:pb-24 mt-0">
        {/* Background Image Container */}
        <div className="absolute inset-0 z-0">
          {/* Update the src path below to point to where you saved the generated image */}
          <img 
            src={heroLV} 
            alt="Loans and Joint Ventures Handshake" 
            className="w-full h-full object-cover"
          />
          {/* Gradient overlay to darken the bottom so text pops perfectly */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
        </div>

        {/* Hero Content (Aligned Bottom Left) */}
        <div className="relative z-10 px-6 md:px-12 w-full max-w-[1400px] mx-auto">
          <div className="max-w-3xl">
            {/* Cyan Badge */}
            <span className="inline-block px-5 py-2 rounded-full bg-[#48DFCB] text-black font-extrabold text-sm md:text-base tracking-wide mb-6">
              Strategic Capital & Funding
            </span>
            
            {/* Golden Title */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-[#E2B764] tracking-tight drop-shadow-lg mb-4">
              Loans & Joint Ventures
            </h1>
            
            {/* White Subtitle */}
            <p className="text-lg md:text-xl text-white font-medium leading-relaxed drop-shadow-md max-w-2xl">
              Empowering high-net-worth investors and businesses with bespoke private placement programs and customized loan arrangement services.
            </p>
          </div>
        </div>
      </section>
      {/* ----------------------------------- */}

      <section className="py-24 px-6 md:px-12 bg-black/10 border-y border-white/20 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="section-badge mb-4">Private Placement Program (PPP)</span>
            <h2 className="text-4xl font-extrabold text-brand-cream mb-6">Joint Venture Investment Opportunities</h2>
            <p className="text-brand-cream-muted text-lg leading-relaxed font-medium max-w-4xl mx-auto">
              EWC provides Algorithmic Portfolio Management and Trading Services to high-net-worth investors in India and abroad through a Joint Venture-based Private Placement Program. The investment structure is designed to ensure full transparency, investor control, and aligned profit-sharing.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {jvHighlights.map((item, idx) => (
              <div key={idx} className="glass-card p-8 shimmer-hover flex flex-col justify-between">
                <div className="relative z-10">
                  <h3 className="text-xl font-extrabold text-brand-gold tracking-wide mb-4">{item.title}</h3>
                  <p className="text-sm text-brand-cream-muted leading-relaxed font-medium">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="glass-card p-10 relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-brand-cream/20 to-transparent pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 md:w-1/3">
              <h3 className="text-2xl font-bold text-brand-gold-light mb-2">Investment Universe</h3>
              <p className="text-brand-cream-muted font-medium">We deploy proprietary trading algorithms across multiple global asset classes.</p>
            </div>
            <div className="relative z-10 md:w-2/3 w-full">
              <ul className="grid sm:grid-cols-2 gap-4">
                {jvMarkets.map((market, idx) => (
                  <li key={idx} className="flex items-center space-x-3 text-brand-cream font-medium text-base">
                    <span className="text-brand-primary bg-gradient-to-br from-brand-gold to-brand-gold-light w-6 h-6 rounded-md flex items-center justify-center shadow-inner font-black text-[10px] shrink-0">
                      ✦
                    </span>
                    <span>{market}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="section-badge mb-4">Financial Assistance</span>
          <h2 className="text-4xl font-extrabold text-brand-cream mb-6">Loan Arrangement Services</h2>
          <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
            EWC assists individuals and businesses in arranging suitable financing solutions through its network of financial institutions and lending partners. Our objective is to help clients identify financing options that align with their specific business and personal requirements.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {loanCategories.map((loan, idx) => (
            <div key={idx} className="glass-card p-5 rounded-2xl hover:bg-brand-cream/20 hover:border-brand-gold-light/40 transition-all flex items-center space-x-4 shadow-md group">
              <span className="text-brand-primary text-xl bg-gradient-to-br from-brand-gold to-brand-gold-light w-10 h-10 rounded-xl flex items-center justify-center shadow-inner font-black group-hover:scale-110 transition-transform shrink-0">
                ✦
              </span>
              <span className="text-sm font-bold text-brand-cream tracking-wide">{loan.name || loan}</span>
            </div>
          ))}
        </div>

        <div className="bg-black/20 p-8 rounded-3xl border border-white/20 backdrop-blur-md text-center max-w-4xl mx-auto">
          <h4 className="text-lg font-bold text-brand-gold-light mb-3">Important Notice & Legal Structure</h4>
          <p className="text-sm text-brand-cream-muted/80 leading-relaxed font-medium">
            Engagement is to be governed under a Joint Venture Agreement / Private Placement Agreement. All terms are subject to applicable laws, regulatory permissions, and jurisdictional compliance. This proposal is not a public offer and is intended solely for eligible private investors. Investment in financial markets involves risk, including the possible loss of capital. Returns are variable, market-linked, and not guaranteed.
          </p>
        </div>
      </section>
    </PageShell>
  );
};

export default LoansJV;